import { supabase } from '../supabaseClient';

/**
 * Initiates the Stripe checkout process for a given price ID.
 * This function assumes a user is already logged in and has a valid session.
 * @param {string} priceId - The ID of the Stripe price to subscribe to.
 * @param {string|null} userId - The ID of the user initiating the checkout.
 * @param {string|null} companyId - The ID of the company to associate with the checkout.
 * @param {function} setError - A state setter function to handle errors in the calling component.
 * @param {function} setIsRedirecting - A state setter to indicate redirection has started.
 */
export const handleSubscribe = async (priceId, userId, companyId, setError, setIsRedirecting) => {
  if (setIsRedirecting) setIsRedirecting(true);
  if (setError) setError(null);

  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) {
      throw new Error("User session not found. Please log in again.");
    }
    const accessToken = session.access_token;
    const apikey = (window.__RUNTIME_CONFIG__ && window.__RUNTIME_CONFIG__.REACT_APP_SUPABASE_ANON_KEY) || process.env.REACT_APP_SUPABASE_ANON_KEY;

    const response = await fetch('/functions/v1/create-checkout-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
        'apikey': apikey,
      },
      body: JSON.stringify({ priceId, userId, companyId }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to create checkout session.");
    }

    // Redirect to Stripe Checkout
    window.location.href = data.url;

  } catch (err) {
    if (setError) setError(err.message);
    if (setIsRedirecting) setIsRedirecting(false);
  }
}; 